<template>

  <div class="flex bg-primary text-white  items-center gap-x-6 overflow-hidden   px-6 py-2.5 sm:px-3.5" v-if="!close">

    <div class="flex flex-wrap items-center gap-x-4 gap-y-2 text-center max-w-screen-lg mx-auto ">
      <p class="text-sm leading-6 text-white">
        <nuxt-link :to="annoucement.data[0].attributes.url"
          :target="annoucement.data[0].attributes.isExternal ? '_blank' : '_self'">


          <strong class="font-semibold text-left "> {{ annoucement.data[0].attributes.text }}
            <span class="relative inline-flex h-3 w-3 m-2 ">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
            </span>

          </strong>


        </nuxt-link>


      </p>
      <a href="#"
        class="hidden flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">Register
        now <span aria-hidden="true">&rarr;</span></a>
    </div>


    <div class="flex flex-1 justify-end">
      <button type="button" class="-m-3 p-3 focus-visible:outline-offset-[-4px]" @click="close = true">
        <span class="sr-only">Dismiss</span>
        <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>
    </div>
  </div>


</template>

<script setup>

const close = ref(false);

const { find } = useStrapi()

const { data: annoucement, pending: pending, error, refresh } = await useAsyncData(
  'annoucement',
  () => find('aa-announcements', {
    sort: 'createdAt:desc'
  })
)


</script>
